<template>
  <div class="CompanyCheckInSuccess">
    <div class="company-info">
      <h3>
        {{
          $t('company-code.check-in-success', {
            split: '/'
          })
        }}
      </h3>
      <v-card class="card">
        <!-- <v-img
          :src="companyInfo.thumbnail"
          class="img"
          alt="cover"
          v-if="companyInfo.thumbnail"
        >
        </v-img> -->
        <!-- <img
          :src="CompanyNoImage"
          class="img"
          alt="No thumnail of company"
          v-else
        /> -->
        <v-card-text class="card-text">
          <v-avatar size="56">
            <img
              alt="avatar"
              :src="companyInfo.company_logo"
              v-if="companyInfo.company_logo"
            />
            <img :src="CompanyNoImage" alt="No logo of company" v-else />
          </v-avatar>
          <div class="right">
            <div class="font-weight-bold ml-3 mb-2 mr-3">
              {{ companyInfo.company_name }}
            </div>
            <p class="ml-3 mr-3">
              {{ companyInfo.business_content }}
            </p>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div class="group-btn mb-3">
      <!-- <router-link tag="button" :to="getCheckInType">
        <v-btn
          color="#e8320d"
          height="50"
          v-html="
            $t('company-code.continue-check-in', {
              split: '<br />'
            })
          "
        >
        </v-btn>
      </router-link> -->
      <div class="margin" style="padding: 20px 0px">
        <router-link tag="button" :to="{ name: 'company-optionscan' }">
          <v-btn
            class="btn-code"
            outlined
            color="#e8320e"
            height="50"
            v-html="
              $t('company-code.back-to-top-page', {
                split: '<br />'
              })
            "
          >
          </v-btn>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyNoImage from '@/assets/image/company-no-image.jpg';
import { COMPANY_SCREEN_ID, PAGE_VIEW } from '@/common/constants';

export default {
  name: 'CompanyCheckInSuccess',
  data: () => {
    return {
      companyID: 0,
      type: '',
      companyInfo: {},
      CompanyNoImage,
      COMPANY_SCREEN_ID,
      PAGE_VIEW
    };
  },
  created() {
    this.companyID = this.$route.params.companyId
      ? this.$route.params.companyId
      : '';
    this.type = this.$route.query.type && this.$route.query.type;
    if (!this.companyID || !this.type) {
      this.$router.push({ name: 'company-optionscan' });
    } else {
      this.$store.dispatch('companyDetail', {
        exhibiting_company_id: this.companyID
      });
    }
  },
  watch: {
    companyDetail: function (val, oldVal) {
      this.companyInfo = val;
      console.log(this.companyInfo);
    }
  },
  methods: {},
  computed: {
    ...mapGetters({
      companyDetail: 'getCompanyInfoDetail'
    }),
    getCheckInType() {
      if (this.type === 'code-scan') {
        console.log(this.type);
        return { name: 'company-codescan' };
      } else {
        return { name: 'company-qrscan' };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';
@import '@/style/devices.scss';
.CompanyCheckInSuccess {
  margin-top: 2rem;
  .company-info {
    h3 {
      color: #e8320d;
      text-align: center;
      border: none !important;
    }
    .card {
      width: 500px;
      box-shadow: none !important;
      margin: 1rem auto;
      .img {
        max-width: 100%;
        height: auto;
      }

      .card-text {
        display: flex;
        .right {
          display: flex;
          flex-direction: column;
          width: 91%;
          p {
            white-space: pre-line;
          }
        }
      }
    }
  }

  .group-btn {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .v-btn {
      width: 350px;
      color: #fff;
      text-transform: unset !important;
    }
    .btn-code {
      margin-top: 0 !important;
    }
    .orderCode {
      color: #fff;
      width: 85%;
      height: 70px;
      font-weight: 900;
      font-size: 40px;
    }

    .title {
      font-weight: 500;
      font-size: 14px !important;
      margin-top: 40px;
      text-align: center;
    }

    .qr-box {
      overflow: hidden;
      background: #fff;
      box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      width: 50%;
      img {
        width: 100%;
      }
    }
  }
  @include mobile {
    .card {
      width: 65vw !important;
    }
    .group-btn {
      .v-btn {
        height: 50px !important;
        font-size: 13px !important;
        width: 14rem !important;
        color: #fff;
      }
    }
  }
}
</style>
